export default __webpack_public_path__ + "static/media/UI_Top.min.601eebf7.png";